import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { isEditUserSettingsWebSupplierGroupDrawer, isOpenUserSettingsWebSupplierGroupDrawer, userSettingsWebSupplierGroupFormData } from "../../@signals"
import WebSupplierGroupDrawerName from "./Name"
import WebSupplierGroupDrawerWebSuppliers from "./WebSuppliers"
import WebSupplierGroupDrawerSubmit from "./Submit"


export default function WebSupplierGroupDrawer() {
	const onClose = () => userSettingsWebSupplierGroupFormData.value = {}

	return <AppFormDrawer
		icon="store"
		title={isEditUserSettingsWebSupplierGroupDrawer.value ? 'Edit Web Supplier Group' : 'New Web Supplier Group'}
		subtitle="A name and the web suppliers it groups"
		isOpen={isOpenUserSettingsWebSupplierGroupDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<WebSupplierGroupDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="store" title="Web supplier group">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><WebSupplierGroupDrawerName/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><WebSupplierGroupDrawerWebSuppliers/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
